import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddProjectComponent } from '../../modals/add-project/add-project.component';
import { SelectsProjectsComponent } from '../../modals/selects-projects/selects-projects.component';
import { DataService } from '../../../services/data.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { InfoModalComponent } from '../../modals/info-modal/info-modal.component';
import { ConfirmSentComponent } from '../../modals/confirm-sent/confirm-sent.component';
import { from, of, throwError } from 'rxjs';
import _ from "lodash";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-list-project',
  templateUrl: './list-project.component.html',
  styleUrls: ['./list-project.component.scss']
})
export class ListProjectComponent implements OnInit {

  public data = [];
  public filteredData = [];
  public pageSize = 5;
  public page = 1;
  public isNoneProjects = true;
  private parentProject;
  private parent;
  public isLoading = false;
  public isLoaded = false;
  public zeus_status = false;
  public isActiveOnly = false;
  public searchTerm = '';
  projectName = environment.projectName

  private options2modal: NgbModalOptions = {
    backdrop: true,
    keyboard: false,
    size: 'xl',
    centered: true,
    windowClass: 'tripUploadModal'
  };

  constructor(
    private modalService: NgbModal,
    private service: DataService
  ) {
  }

  ngOnInit() {
    this.zeus_status = localStorage.getItem('zeus_status') === 'true';
    this.fetchData();
  }

  searchProject(event) {
    this.filteredData = this.data.filter((itm) => {
      const isIncluded = itm.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      if (this.isActiveOnly) return itm.freeToRegister && isIncluded;
      else return isIncluded;
    });
  }

  filterList() {
    this.isActiveOnly = !this.isActiveOnly;
    this.searchProject(this.searchTerm)
  }

  openAddProject() {
    var modalRef = this.modalService.open(AddProjectComponent, this.options2modal);
    modalRef.componentInstance.headline = "Add Project";
    modalRef.componentInstance.btnText = "Add";
    modalRef.componentInstance.project.address = {
      country: this.parent ? this.parent.country.toLowerCase() : null,
      postalCode: this.parent ? this.parent.postalCode : null,
      municipality: this.parent ? this.parent.municipality : null,
      street: this.parent ? this.parent.street : null,
      houseNumber: this.parent ? this.parent.houseNumber : null,
      boxNumber: this.parent ? this.parent.boxNumber : null
    };
    modalRef.componentInstance.project.point = this.parent ? _.cloneDeep(this.parent.center) : null;
    modalRef.result.then((project) => {
      this.service.createSubProject({
        lng: 'ENG', //FIXME
        location: project.point,
        emailLeader: project.email,
        parentId: this.parentProject.projectID.id,
        address: project.address,
        name: project.name
      }).subscribe(response => this.fetchData());
    }, (reason) => {
      // on dismiss
    });
  }

  openSelectProject() {
    this.modalService.open(SelectsProjectsComponent, this.options2modal).result.then(projects => console.log(projects));
  }

  updateProject($event, it) {
    this.isLoading = true;
    this.service
      .getProjectData(it.id)
      .pipe(
        switchMap(project => {
          return this
            .service
            .getProjectLeaderEmail(project.projectID.id)
            .pipe(map(email => Object.assign(project, { email: email.text })))
        }),
        switchMap(project => {
          this.isLoading = false;
          return of({
            attributes: project.attributes,
            boundaries: { coordinates: [[[[0, 1], [1, 1], [1, 0], [0, 1]]]], type: 'MultiPolygon' },
            boxNumber: project.boxNumber,
            center: project.center,
            childTransmissionEnabled: project.childTransmissionEnabled,
            children: project.children,
            childrenEnabled: project.childrenEnabled,
            country: project.country,
            freeToRegister: $event.target.checked,
            houseNumber: project.houseNumber,
            location: project.location,
            municipality: project.municipality,
            name: project.name,
            notifyProjectLeadersOnInbox: project.notifyProjectLeadersOnInbox,
            parentID: project.parentID,
            phoneNumberRequired: project.phoneNumberRequired,
            postalCode: project.postalCode,
            projectID: project.projectID,
            radius: project.radius,
            street: project.street,
            visibility: 'PUBLIC'
          })
        }),
        switchMap(updatedProject => this.service.updateProject(updatedProject, false)),
        catchError(error => {
          if (error != "close" && error) {
            const infoDlg = this.modalService.open(InfoModalComponent);
            infoDlg.componentInstance.data = {
              text: `Internal Server Error \n ${error.error.message}`,
              header: 'Error'
            };
            return throwError(infoDlg.result);
          }
          return throwError(error);
        }),
        switchMap(project => {
          const infoDlg = this.modalService.open(InfoModalComponent);
          infoDlg.componentInstance.data = {
            text: 'The project has been updated',
            header: 'Info'
          };
          return from(infoDlg.result);
        })
      )
      .subscribe(response => {
        this.fetchData();
      }, error => {
        if (error == "close" || !error) { return ''; }
        else { return console.log(error); }
      });
  }

  public delete(project) {
    const confirm = this.modalService.open(ConfirmSentComponent);
    confirm.componentInstance.data = {
      text: 'Are you sure you want to remove the selected projects',
      header: 'Remove projects'
    };
    confirm.result.then(ok => {
      this.service.deleteProject(project.id).subscribe(response => {
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'The project has been deleted',
          header: 'Info'
        };
        infoDlg.result.then(ok => {
          this.fetchData();
        });
      }, error => {
      });
    }).catch(reason => {
    });
  }

  public edit(project) {
    this.isLoading = true;
    this.service
      .getProjectData(project.id)
      .pipe(
        switchMap(project => {
          return this
            .service
            .getProjectLeaderEmail(project.projectID.id)
            .pipe(map(email => Object.assign(project, { email: email.text })))
        }),
        switchMap(project => {
          this.isLoading = false;
          const editDlg = this.modalService.open(AddProjectComponent, this.options2modal);
          editDlg.componentInstance.headline = "Edit Project";
          editDlg.componentInstance.btnText = "Save";
          editDlg.componentInstance.project = {
            id: project.projectID.id,
            name: project.name,
            email: project.email,
            point: project.location,
            freeToRegister: project.freeToRegister,
            address: {
              country: project.country,
              postalCode: project.postalCode,
              municipality: project.municipality,
              street: project.street,
              houseNumber: project.houseNumber,
              boxNumber: project.boxNumber
            }
          };
          return from(editDlg.result).pipe(
            map(newUiProject => {
              return {
                attributes: project.attributes,
                boundaries: { coordinates: [[[[0, 1], [1, 1], [1, 0], [0, 1]]]], type: 'MultiPolygon' },
                boxNumber: newUiProject.address.boxNumber,
                center: newUiProject.point,
                childTransmissionEnabled: project.childTransmissionEnabled,
                children: project.children,
                childrenEnabled: project.childrenEnabled,
                country: newUiProject.address.country,
                freeToRegister: newUiProject.freeToRegister,
                houseNumber: newUiProject.address.houseNumber,
                location: newUiProject.point,
                municipality: newUiProject.address.municipality,
                name: newUiProject.name,
                notifyProjectLeadersOnInbox: project.notifyProjectLeadersOnInbox,
                parentID: project.parentID,
                phoneNumberRequired: project.phoneNumberRequired,
                postalCode: newUiProject.address.postalCode,
                projectID: project.projectID,
                radius: project.radius,
                street: newUiProject.address.street,
                visibility: 'PUBLIC'
              }
            }));
        }),
        switchMap(updatedProject => this.service.updateProject(updatedProject, false)),
        catchError(error => {
          if (error != "close" && error) {
            const infoDlg = this.modalService.open(InfoModalComponent);
            infoDlg.componentInstance.data = {
              text: `Internal Server Error \n ${error.error.message}`,
              header: 'Error'
            };
            return throwError(infoDlg.result);
          }
          return throwError(error);
        }),
        switchMap(project => {
          const infoDlg = this.modalService.open(InfoModalComponent);
          infoDlg.componentInstance.data = {
            text: 'The project has been updated',
            header: 'Info'
          };
          return from(infoDlg.result);
        })
      )
      .subscribe(response => {
        this.fetchData();
      }, error => {
        if (error == "close" || !error) return "";
        else return console.log(error);
      });

  }

  private fetchData() {
    this.isNoneProjects = true;
    this.isLoaded = false;
    this.parentProject = JSON.parse(localStorage.getItem('project_id'));
    this.data = [];
    this.service.getProjectData(this.parentProject.projectID.id).subscribe(parent => {
      if (parent.children.length == 0) {
        this.isLoaded = true;
      }
      this.parent = parent;
      parent.children.forEach(child => {
        this.service.getProjectData(child.id).pipe(
          switchMap(response => {
            return this
              .service
              .getProjectLeaderEmail(response.projectID.id)
              .pipe(map(email => Object.assign(response, { email: email.text })))
          }),
          map(response => {
            return {
              id: response.projectID.id,
              name: response.name,
              email: response.email,
              street: response.street,
              house: response.houseNumber,
              zip: response.postalCode,
              country: (response.country || '').toLowerCase(),
              freeToRegister: response.freeToRegister
            }
          }
          )
        ).subscribe(project => {
          this.data.push(project);
          this.data.sort((a, b) => {
            if (a.name > b.name) {
              return 1;
            } else {
              return -1;
            }
          });
          this.filteredData = this.data;
          this.isNoneProjects = false;
          this.isLoaded = true;
        }, error => {
          console.log(error);
          this.isNoneProjects = true;
          this.isLoaded = true;
        });
      });
    });
  }
}
